import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import { ParticipantViewModel, ParticipantVirtualGraduationState, UserRole } from 'stageclip-common';
import { faEye } from '@fortawesome/free-solid-svg-icons';

import { ParticipantsState } from '../../events/participants/participantsState';
import { ParticipantsVirtualGraduationState } from '../../events/participants/participantsVirtualGraduationState';

import { QaQueueReviewModal } from './reviewModal/QaQueueReviewModal';
import { callApi } from 'helpers/callApi/callApi';
import { AppTable, AppTableColumn } from 'components/table/appTable';
import DownloadButton from 'components/buttons/downloadButton';
import Button from 'components/buttons/button';

const formatValue = ({ value, replaceWith = 'n/a' }: { value: unknown; replaceWith?: unknown }) => value || replaceWith;

type QaQueueListProps = any;
type QaQueueListState = {
  loading: boolean;
  error: boolean;
};

export class QaQueueList extends Component<QaQueueListProps, QaQueueListState> {
  private columns: AppTableColumn[] = [
    {
      Header: 'Id',
      accessor: (p: ParticipantViewModel) => p.id,
      id: 'id',
      width: 240,
    },
    {
      Header: 'Full name',
      accessor: (p: ParticipantViewModel) => p.fullName,
      id: 'fullName',
      width: 200,
    },
    {
      Header: 'Subtitle',
      accessor: (p: ParticipantViewModel) => p.subtitle,
      id: 'subtitle',
      width: 200,
    },
    {
      Header: 'Second Subtitle',
      accessor: (p: ParticipantViewModel) => p.secondSubtitle,
      id: 'secondSubtitle',
      width: 200,
    },
    {
      Header: 'Client participant ID',
      accessor: (p: ParticipantViewModel) => formatValue({ value: p.clientParticipantId }),
      id: 'clientParticipantId',
      width: 80,
    },
    {
      Header: 'Marching Order ID',
      accessor: (p: ParticipantViewModel) => formatValue({ value: p.marchingOrderParticipantId }),
      id: 'marchingOrderParticipantId',
      width: 80,
    },
    {
      Header: 'e-mail',
      accessor: (p: ParticipantViewModel) => formatValue({ value: p.email }),
      id: 'email',
      width: 200,
    },
    {
      Cell: (row: any) => <ParticipantsState state={row.value} />,
      Header: 'State',
      accessor: (p: ParticipantViewModel) => p.state,
      id: 'state',
      width: 140,
    },
    {
      Cell: (row: any) => <ParticipantsVirtualGraduationState state={row.value} />,
      Header: 'VG State',
      accessor: ({ virtualGraduation }: ParticipantViewModel) => virtualGraduation && virtualGraduation.state,
      id: 'vgState',
      width: 140,
    },
    {
      Cell: ({ value }) => formatValue({ value }),
      Header: 'Snapcode Id',
      accessor: (p: ParticipantViewModel) => p.snapcodeId,
      id: 'snapcodeId',
      width: 230,
    },
    {
      Cell: (row: any) => formatValue({ value: row.value && <DownloadButton url={row.value} /> }),
      Header: 'Slide Image',
      accessor: (p: ParticipantViewModel) => p.virtualGraduation?.image,
      id: 'image',
      width: 120,
    },
    {
      Header: 'Slide Message',
      accessor: (p: ParticipantViewModel) => formatValue({ value: p.virtualGraduation?.message }),
      id: 'message',
      width: 120,
    },
    {
      accessor: ({ virtualGraduation }: ParticipantViewModel) =>
        formatValue({ value: virtualGraduation && virtualGraduation.file }),
      id: 'virtualGraduationVideoUrl',
      show: false,
    },
    {
      Cell: ({ original }: { original: ParticipantViewModel }) => {
        const { openVideoReviewModal } = this.props;

        return (
          <Button
            text="review"
            onClick={() => openVideoReviewModal(original)}
            icon={faEye}
            allCapitals
            slimButton
            disabled={
              !original.virtualGraduation ||
              original.virtualGraduation.state === ParticipantVirtualGraduationState.Rejected
            }
          />
        );
      },
      Header: 'Review virtual graduation',
      width: 100,
      // eslint-disable-next-line react/destructuring-assignment
      show: this.props.currentUser.role === UserRole.Admin || this.props.currentUser.role === UserRole.Clipper,
    },
  ];

  constructor(props: any) {
    super(props);

    this.state = {
      loading: false,
      error: false,
    };
  }

  componentDidMount() {
    const { fetchQaQueueParticipants, fetchEvents } = this.props;

    this.setState({ loading: true });

    Promise.all([
      callApi({
        action: fetchQaQueueParticipants,
      }),
      callApi({
        action: fetchEvents,
      }),
    ])
      .then(() => {
        this.setState({ loading: false, error: false });
      })
      .catch(() => {
        this.setState({ loading: false, error: true });
      });
  }

  componentWillUnmount() {
    const { resetParticipantsListAction } = this.props;

    resetParticipantsListAction();
  }

  render() {
    const { participants } = this.props;
    const { loading, error } = this.state;

    if (error) {
      return <div>Something went wrong. Try refresh page</div>;
    }

    return (
      <div>
        {loading && <BeatLoader />}
        {loading || (
          <>
            <AppTable columns={this.columns} data={participants} />
            <QaQueueReviewModal />
          </>
        )}
      </div>
    );
  }
}
